import { render, staticRenderFns } from "./DespachoProducto.vue?vue&type=template&id=137d1202&"
import script from "./DespachoProducto.vue?vue&type=script&lang=js&"
export * from "./DespachoProducto.vue?vue&type=script&lang=js&"
import style0 from "./DespachoProducto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports